<script>
export default {
    props: {
        account: {},
        dir: {},
        end: {},
        sort: {},
        start: {},
        status: {},
        orders: {},
        order: {},
        po: {},
        item: {},
    },
    data: () => ({
        accountNumber: null,
        dates: {
            startDate: null,
            endDate: null,
        },
        itemNumber: null,
        limit: 10,
        orderNumber: null,
        orderStatus: '',
        page: 1,
        poNumber: null,
        sortDir: null,
        sortField: null,
    }),
    computed: {
        paginatedOrders() {
            const start = (this.page - 1) * this.limit
            return Object.values(this.orders).slice(start, start + this.limit)
        },
        resultsInfo() {
            const start = (this.page - 1) * this.limit + 1
            const end = Math.min(this.page * this.limit, Object.values(this.orders).length)
            return `${start}–${end} of ${Object.values(this.orders).length} Results`
        },
        totalPages() {
            return Math.ceil(Object.values(this.orders).length / this.limit)
        },
    },
    methods: {
        setDates(dates) {
            this.dates = dates
        },

        changeStatusTab(status) {
            const newStatus = typeof status === 'object' ? status?.target?.value : status
            return this.baseSearch({ status: newStatus })
        },

        setStatus(status) {
            const newStatus = typeof status === 'object' ? status?.target?.value : status
            this.orderStatus = newStatus
        },

        setAccount(acct) {
            this.accountNumber = typeof acct === 'object' ? acct?.target?.value : acct
            return this.baseSearch()
        },

        setPONumber(acct) {
            this.poNumber = typeof acct === 'object' ? acct?.target?.value : acct
        },

        setOrderNumber(acct) {
            this.orderNumber = typeof acct === 'object' ? acct?.target?.value : acct
        },

        setItemNumber(acct) {
            this.itemNumber = typeof acct === 'object' ? acct?.target?.value : acct
        },

        setPage(page) {
            this.page = page
            scrollTo(0, window.pageYOffset + this.$el.getBoundingClientRect().top + 160)
        },

        sortOn(field) {
            if (field != this.sortField) {
                this.sortField = field
                this.sortDir = field === 'date' ? 'desc' : 'asc'
            } else {
                this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc'
            }
            this.search()
        },

        baseSearch(extra = {}) {
            let params = {
                start: this.dates.startDate.toLocaleDateString(),
                end: this.dates.endDate.toLocaleDateString(),
                acct: this.accountNumber,
            }

            params = Object.assign({}, params, extra)

            window.location.search = (new URLSearchParams(params)).toString()
        },

        search(extra = {}) {
            let params = {
                status: this.orderStatus,
                sort: this.sortField,
                dir: this.sortDir,
            }

            if (this.poNumber) {
                params.po = this.poNumber
            }
            if (this.itemNumber) {
                params.item = this.itemNumber
            }
            if (this.orderNumber) {
                params.order = this.orderNumber
            }

            return this.baseSearch(params)
        },

        formatCurrency(amt, currency = 'usd') {
            if (!currency) {
                currency = 'usd'
            }
            const formatter = new Intl.NumberFormat(
                navigator.language || 'en-us',
                { style: 'currency', currency }
            )
            return formatter.format(amt)
        },

        formatDate(date) {
            const d = new Date(date * 1000)
            return d.toLocaleDateString(navigator.language || 'en-us', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
            })
        },
    },
    render() {
        return this.$scopedSlots.default({
            account: this.accountNumber,
            changeStatusTab: this.changeStatusTab,
            dates: this.dates,
            formatCurrency: this.formatCurrency,
            formatDate: this.formatDate,
            item: this.itemNumber,
            order: this.orderNumber,
            page: this.page,
            paginatedOrders: this.paginatedOrders,
            po: this.poNumber,
            resetFilters: this.baseSearch,
            resultsInfo: this.resultsInfo,
            search: this.search,
            setAccount: this.setAccount,
            setDates: this.setDates,
            setItemNumber: this.setItemNumber,
            setOrderNumber: this.setOrderNumber,
            setPONumber: this.setPONumber,
            setPage: this.setPage,
            setStatus: this.setStatus,
            sortOn: this.sortOn,
            status: this.orderStatus,
            totalPages: this.totalPages,
        })
    },
    mounted() {
        if (this.start) {
            this.dates.startDate = new Date(this.start)
        }
        if (this.end) {
            this.dates.endDate = new Date(this.end)
        }
        if (this.status) {
            this.orderStatus = this.status
        }
        if (this.account) {
            this.accountNumber = this.account
        }
        if (this.po) {
            this.poNumber = this.po
        }
        if (this.item) {
            this.itemNumber = this.item
        }
        if (this.order) {
            this.orderNumber = this.order
        }
        if (this.sort) {
            this.sortField = this.sort
        }
        if (this.dir) {
            this.sortDir = this.dir
        }
    },
}
</script>
